import { render, staticRenderFns } from "./org-row.vue?vue&type=template&id=b2785b84&"
import script from "./org-row.vue?vue&type=script&lang=ts&"
export * from "./org-row.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports